<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" compact="true"></app-side-menu>

<app-nav-bar [sideBar]="false" (navMessage$)="listenerNav($event)"></app-nav-bar>

<app-footer [sideBar]="false"></app-footer>

<div class="content-page">

    <div class="content">

        <div class="container-fluid">

            <aside>
                
                @if (terms && terms.id) {
                    <div class="card">
                        <div class="card-body">
                            <h3>{{terms.method}}</h3>
                            <p class="subtitle">{{terms.type}}</p>
                            
                            <h3>{{terms.balance | currency}}</h3>
                            <p class="subtitle">Principal Balance</p>

                            <h3>{{terms.unpaidEarnedInterest | currency}}</h3>
                            <p class="subtitle">Unpaid Earned Interest</p>

                            <h3>{{terms.taxBalance | currency}}</h3>
                            <p class="subtitle">Tax Balance</p>

                            @if (terms.lateFees) {
                            <h3>{{terms.lateFees | currency}}</h3>
                            <p class="subtitle">Late Fees</p>
                            }

                            <h3>{{terms.payoff | currency}}</h3>
                            <p class="subtitle">Payoff</p>

                            <h3>{{terms.payment | currency}}</h3>
                            <p class="subtitle">{{terms.frequency | titlecase}} Payment</p>

                            <h3 class="due {{dueToClass(terms.due)}}">{{terms.due | date:'E MMM d, yyyy'}}</h3>
                            <p class="subtitle">Due Date</p>

                            <h3 class="due {{dueToClass(terms.due)}}">{{terms.total() | currency}}</h3>
                            <p class="subtitle">Amount Due</p>
                        </div>
                        <div class="card-footer">
                            <p class="card-text text-right">as of {{terms.day | date:'E MMM d, yyyy'}}</p>
                        </div>
                    </div>

                    <div class="card">
                        @if (terms.url) {
                        <img [src]="terms.url" width="50%" class="card-img-top" />
                        }

                        <div class="card-body">                            
                            <h3>{{terms.sold | date:'E MMM d, yyyy'}}</h3>
                            <p class="subtitle text-truncate">{{terms.status}}</p>

                            <h3>{{terms.contact}}</h3>
                            <p class="subtitle">Buyer</p>

                            <h3>{{terms.vehicle}}</h3>
                            <p class="subtitle">{{terms.stock}} | {{terms.vin}}</p>
                        </div>
                    </div>
                }

            </aside>

            <main>

                <header>
                    <h2>Payment Editor</h2>
                    <nav>
                        <button class="btn btn-sm btn-light" [routerLink]="['/sales', saleId]"><span class="material-icons">directions_car</span> sale</button>
                        <button class="btn btn-sm btn-light" [routerLink]="['/collections', contactId]"><span class="material-icons">attach_money</span> collections</button>
                    </nav>
                </header>

                <form [formGroup]="form">
                    <ng-container formArrayName="payments">

                        <table class="table table-sm table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col">Received</th>
                                    <th scope="col">Due</th>
                                    <th class="text-center" scope="col">Days Late</th>
                                    <th class="text-right" scope="col">Late Fee</th>
                                    <th class="text-center" scope="col">Kind</th>
                                    <th class="text-right" scope="col">Amount Due</th>
                                    <th class="text-right" scope="col">Amount</th>
                                    <th scope="col">Method</th>
                                    <th scope="col">Extra</th>
                                    <th class="text-right" scope="col">Balance</th>
                                    <th class="text-right" scope="col">Payoff</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (paymentForm of payments.controls; track paymentForm; let i = $index) {
                                    <tr [formGroup]="paymentForm">
                                        <td><input type="date" class="form-control form-control-sm" formControlName="received" (blur)="receivedChanged($event, i)" /></td>
                                        <td><input type="text" readonly class="form-control-plaintext form-control-sm" formControlName="due" /></td>
                                        <td><input type="text" readonly class="form-control-plaintext form-control-sm text-center" [class.text-danger]="paymentForm.get('daysLate').value >= 16" formControlName="daysLate" /></td>
                                        <td><input type="text" readonly class="form-control-plaintext form-control-sm text-right" formControlName="lateFee" /></td>
                                        <td>
                                            @if (paymentForm.get('id').value) {
                                                <input type="text" readonly class="form-control-plaintext form-control-sm text-center" formControlName="category" />
                                            }
                                            @else {
                                                <select class="form-control form-control-sm" formControlName="category" (change)="kindChanged($event, i)" >
                                                    @for (kind of kindsAvailable(paymentForm.get('received').value); track kind) {
                                                        <option value="{{kind | lowercase}}">{{kind}}</option>
                                                    }
                                                </select>
                                            }
                                        </td>
                                        <td><input type="text" readonly class="form-control-plaintext form-control-sm text-right" formControlName="amountDue" /></td>
                                        <td><currency-input [id]="'payment-amount-' + i" [control]="paymentForm.get('amount')"></currency-input></td>
                                        <td>
                                            <select class="form-control form-control-sm" formControlName="method">
                                                @for (method of paymentMethods; track method) {
                                                    <option value="{{method | lowercase}}">{{method}}</option>
                                                }
                                            </select>
                                        </td>
                                        <td>
                                            @if (paymentForm.get('method').value === 'cash') {
                                                <currency-input [id]="'payment-paidin100s-' + i" [control]="paymentForm.get('paidIn100s')" [placeHolder]="'paidIn100s'"></currency-input>
                                            }
                                            @else if (['check', 'cashiers check', 'travelers check'].includes(paymentForm.get('method').value)) {
                                                <input type="text" class="form-control form-control-sm" formControlName="checkNumber" placeholder="check #" />
                                            }
                                            @else {
                                                <button class="btn btn-sm btn-block btn-link" (click)="details($event, i)">details</button>
                                            }
                                        </td>
                                        <td><input type="text" readonly class="form-control-plaintext form-control-sm text-right" formControlName="endBalance" /></td>
                                        <td>
                                            @if (!paymentForm.get('id').value) {
                                                <input type="text" readonly class="form-control-plaintext form-control-sm text-right" formControlName="payoff" />
                                            }
                                        </td>
                                        <td class="actions">
                                            @if (paymentForm.pristine && paymentForm.get('id').value) {
                                                <span class="material-icons" (click)="receipt(i)">receipt</span>
                                            }
                                            @else {
                                                <span class="material-icons" [class.text-primary]="paymentForm.valid" (click)="save(i)">save</span>
                                            }
                                            <span class="dripicons-trash text-danger" (click)="discard(i)"></span>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>

                        @if (payments.dirty) {
                            <div class="fab save"><button class="btn btn-primary" (click)="saveAll($event)"><span class="material-icons">save</span></button></div>
                        }
                        <div class="fab"><button class="btn btn-success" (click)="add($event)"><span class="uil-plus"></span></button></div>

                    </ng-container>
                </form>

            </main>

        </div>

    </div>

</div>

<button id="toggleDetailView" [attr.data-target]="'#detailViewModal'" data-toggle="modal" class="d-none"></button>
<div class="modal fade" data-backdrop="static" id="detailViewModal" tabindex="-1" role="dialog" aria-labelledby="viewPaymentDetail">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                @if ((detailIndex >= 0) && (detailIndex <= (payments.length - 1))) {
                    <form [formGroup]="payments.at(detailIndex)">
                        <div class="form-group">
                            <label for="referenceId">Vendor Payment Reference</label>
                            <input type="text" id="referenceId" class="form-control form-control-sm" formControlName="reference" />
                        </div>
                        @if (['credit card', 'debit card', 'prepaid debit card'].includes(payments.at(detailIndex).get('method').value)) {
                            <div class="form-group">
                                <label for="authId">Card Authorization Identity</label>
                                <input type="text" id="authId" class="form-control form-control-sm" formControlName="auth" />
                            </div>
                            <div class="form-group">
                                <label for="approvalCode">Card Approval Code</label>
                                <input type="text" id="approvalCode" class="form-control form-control-sm" formControlName="approval" />
                            </div>
                        }
                        @if (['bank draft'].includes(payments.at(detailIndex).get('method').value)) {
                            <div class="form-group">
                                <label for="batchId">Bacth Identity</label>
                                <input type="text" id="batchId" class="form-control form-control-sm" formControlName="batch" />
                            </div>
                            <div class="form-group">
                                <label for="routingNumber">Bank Routing Number</label>
                                <input type="text" id="routingNumber" class="form-control form-control-sm" formControlName="route" />
                            </div>
                        }
                        <div class="form-group">
                            <label for="lastFour">Account Last Four (Digits)</label>
                            <input type="text" id="lastFour" class="form-control form-control-sm" formControlName="lastFour" />
                        </div>
                    </form>
                }
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" id="close-pay-detail-modal">{{words[language][ 'close' ]}}</button>
            </div>
        </div>
    </div>
</div>

<receipt [id]="receiptId" (closed)="receiptClosed($event)"></receipt>